module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-content"
  }, [(!_vm.isConnectedToScanner) ? _c('p', {
    staticClass: "mt-5",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle fa-3x text-muted fa-border",
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "2px solid red"
    },
    on: {
      "click": function($event) {
        _vm.openBarcodeScannerModal()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.isConnectedToScanner) ? _c('p', {
    staticClass: "mt-5",
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "right": "0",
      "color": "red"
    }
  }, [_c('i', {
    staticClass: "fa fa-circle-plus fa-3x text-muted fa-border",
    staticStyle: {
      "margin-left": "10px",
      "margin-right": "10px",
      "border": "2px solid Green"
    },
    on: {
      "click": function($event) {
        _vm.disconnectFromBarcodeScanner()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.showBarcodeScannerModal) ? _c('barcode-scanner-detail-modal', {
    on: {
      "close": function($event) {
        _vm.showBarcodeScannerModal = null, _vm.isConnectedToBarcodeScanner()
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67c360c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/barcode-scanner/SelectBarcodeScannerWidget.vue
// module id = 728
// module chunks = 1